export default __webpack_public_path__ + "static/bills_codebook-42211a4a17dcbdc80ef527011ba1fa09.pdf";